import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem } from '@mui/material';
import { Kbd } from 'shared/components/kbd/kbd';
export function KeyboardShortcutsItem({ shortcut }) {
    return (_jsxs(ListItem, { children: [_jsx(Kbd, { children: shortcut.key }), " - ", shortcut.text] }));
}
